import { RootState } from 'reducers/rootReducer';
import { PayloadAction } from 'types/payloadAction';

// Action Types
const NAME = 'glaBreakdownModal';

const SHOW = `${NAME}/SHOW`;
const HIDE = `${NAME}/HIDE`;

export interface GlaBreakdownModalState {
  readonly isShowing: boolean;
}

// Initial State
const initialState: GlaBreakdownModalState = {
  isShowing: false,
};

// Action Creators
export const actions = {
  hide: () => ({ type: HIDE }),
  show: () => ({ type: SHOW }),
};

// Selectors
const getAreaTypeModal = (rootState: RootState): GlaBreakdownModalState => rootState.glaBreakdownModal;

const isShowing = (rootState: RootState): boolean => getAreaTypeModal(rootState).isShowing;

export const selectors = {
  isShowing,
};

// Reducers
const showReducer = (state: GlaBreakdownModalState): GlaBreakdownModalState => ({
  ...state,
  isShowing: true,
});

const hideReducer = (state: GlaBreakdownModalState): GlaBreakdownModalState => ({
  ...state,
  isShowing: false,
});

export const reducer = (
  state: GlaBreakdownModalState = initialState,
  action: PayloadAction,
): GlaBreakdownModalState => {
  switch (action.type) {
    case HIDE:
      return hideReducer(state);

    case SHOW:
      return showReducer(state);

    default:
      return state;
  }
};
